import React from "react";
import { formatDays, getAvailableBalance } from "../utils/leaveHelpers";
import "./LeaveBalanceNotice.css";

export function hasInsufficientBalance(type, balance, requested) {
  return Boolean(type?.requiresBalance && !type?.allowNegativeBalance && balance && requested > getAvailableBalance(balance));
}

export default function LeaveBalanceNotice({ type, balance, requested, id = "leave-balance-notice" }) {
  if (!hasInsufficientBalance(type, balance, requested)) return null;
  const available = Math.max(0, getAvailableBalance(balance));
  const progress = balance.attendanceAccrual;
  const standardEl = progress?.planId === "HR_STANDARD" && progress.method === "ATTENDANCE";
  const elRemaining = standardEl ? progress.presentDaysPerCredit - progress.presentDays % progress.presentDaysPerCredit : 0;
  const next = balance.attendanceAccrual?.milestones?.find(step => !step.earned);
  const remaining = next ? Math.max(0, next.presentDays - balance.attendanceAccrual.presentDays) : 0;
  return <div id={id} className="se-leave-balance-notice" role="status" aria-live="polite">
    <span className="se-leave-balance-notice-icon" aria-hidden="true">i</span>
    <div><strong>{available === 0 ? "No leave available yet" : "Not enough leave for these dates"}</strong>
      <p>You have {formatDays(available)} {available === 1 ? "day" : "days"} available. This request needs {formatDays(requested)} {requested === 1 ? "day" : "days"}.</p>
      <small>{standardEl ? progress.earned >= progress.maximum ? "You have reached the earned leave limit for this period." : `Complete ${elRemaining} more full present ${elRemaining === 1 ? "day" : "days"} to earn your next EL credit.` : next ? remaining > 0
        ? `Complete ${remaining} more full present ${remaining === 1 ? "day" : "days"} to qualify for your next ${formatDays(next.credit)}-day credit in ${next.month}. Sundays do not count.`
        : `Your next ${formatDays(next.credit)}-day credit unlocks in ${next.month}.`
        : available >= 0.5 && type.allowHalfDay ? "Choose a half day or shorten your date range to use your available balance." : "You can submit a request once enough leave is available. Contact HR if your balance looks incorrect."}</small>
    </div>
  </div>;
}
